import { useNavigate, useParams } from 'react-router-dom'
import { TabContext, TabList, TabPanel } from '@mui/lab'
import { Box, Button, Typography, Tab, Drawer, IconButton } from '@mui/material'
import { useStyles } from './styles'
import { DinamicForm } from '../../../../../../components/dinamicForm'
import { useCreatEdit } from './hooks/useForms'
import { useGetData } from './hooks/useGetData'
import { useInput } from './hooks/useInputs'
import { useTranslation } from 'react-i18next'
import { BreadCrumb, CustomTable, SnackSimple } from '../../../../../../components'
import Loader from '../../../../../../components/loader'
import { useContextState } from '../../../../../../hooks/theme'
import { useTables } from './hooks/useTable'
import { useTabs } from '../../../../../../hooks/tabs/useTabs'
import { useEffect, useMemo, useState } from 'react'
import { TabDepartment } from '../../typing/enums'
import { icons } from '../../../../../../utils/icons'
import SimpleModal from '../../../../../../components/modal/simpleModal'
import { generalDisabled, isEmail, isPhoneNumber } from '../../../../../../utils/validate/validate'
import { createEdit } from './constants/forms'
import { submit } from './methods'
import { Item } from '../../../../../../utils/types/generals'
import { Types } from '../../../../../../utils/enums'
import { FiltersDrawer } from '../../../../../../components/filtersDrawer'
import { useFilter } from './hooks/useFilter'
import { AddUsers } from '../../../../../questionnaire/pages/permission/fragments'

const FormDepartment = () => {
  const styles = useStyles()
  const { t } = useTranslation()
  const { colors } = useContextState()
  const { id } = useParams()
  const navigate = useNavigate()
  const [userSelected, setUserSelected] = useState<Record<string, boolean>>({})
  const { items, itemsSetting, loadingTable, userTable, loadingDetail, dataEndpoint, } = useGetData()
  const { input, settingInput, inputFilter, createFilter, loadings, cancelSearchUsers, searchUsers, snackbar, modalLoad, inputCreate, setSnackbar, loadUsers, closeSnackbar, } = useInput({ items, itemsSetting, setUserSelected, userSelected })
  const { data, dataSetting, onChange, onChangeSetting, handleFolioSetting, handledata } = useCreatEdit()
  const { value, handleChange } = useTabs()
  const { dataFilter, counter, filterChange, cleanFilter, filterRow } = useFilter()
  const {
    column: columnFolio,
    row: rowFolio,
    openDrawer,
    openModal,
    userFolioSelected,
    closeDrawer,
    closeModal,
    setSettings,
    handleSelect,
    handleSelectUser,
    setAllUsers,
    rowFiltered,
    setAllSettingsFolioUser,
    deleteSelected,
    deletedUsersSelecteds,
    setDeletedSelected
  } = useTables({ tab: value, userTable, handleFolioSetting, setUserSelected, userSelected, dataFilter, filterRow })
  const [submitLoading, setSubmitLoading] = useState(false)
  const [userTableLocale, setUserTableLocale] = useState(userTable)

  const [submitModal, setSubmitModal] = useState<{
    open: boolean
    openSnackbar: boolean
    title: string
    description: string
    id: string | number
    type: Types
  }>({
    title: '',
    description: '',
    id: '',
    open: false,
    openSnackbar: false,
    type: Types.SUCCESS,
  })

  const [backModal, setBackModal] = useState<{
    open: boolean
    title: string
    type: Types
  }>({
    open: false,
    title: t('general.exit'),
    type: Types.SUCCESS,
  })

  const getSwitchValues = ({ value }: { value: boolean }) => {
    if (!id && !!userTable?.length) {
      let body: Record<string, boolean> = {}

      userTable?.forEach((itemUsers) => {
        body = {
          ...body,
          [itemUsers.id]: value,
        }
      })
      setUserTableLocale(userTable)
      setAllUsers({ newSelected: body })
    } else {
      if (!!id) {
        let body: Record<string, boolean> = {}
        let bodyFolio: Record<
          string,
          {
            status: boolean
            reassignFolio: boolean
            hierarchy: boolean
            settings?:
            | {
              users: Item[]
              usersTypes: Item[]
              stores: Item[]
            }
            | undefined
          }
        > = {}

        dataEndpoint.users?.forEach((itemUsers) => {
          let newReceive: Record<string, Item[]> = {}

          Object.entries(itemUsers?.receive ?? {}).forEach(([key, itemReceive]) => {
            let newValueSetting: Item[] = []
            itemReceive.forEach((itemTy) => {
              const item = itemsSetting?.[key]?.find((itemA) => itemA?.value === itemTy?.value)
              if (!!item) {
                newValueSetting = [...newValueSetting, item]
              }
            })
            newReceive = {
              ...newReceive,
              [key]: newValueSetting,
            }
          })

          bodyFolio = {
            ...bodyFolio,
            [itemUsers.id]: {
              ...bodyFolio[itemUsers.id],
              status: !!itemUsers?.status,
              reassignFolio: !!itemUsers?.reassignFolio,
              hierarchy: !!itemUsers?.hierarchy,
              settings: !!Object.values(newReceive)?.length ? newReceive : undefined,
            },
          }

          body = {
            ...body,
            [itemUsers.id]: true,
          }
        })
        const userTableSort = userTable?.sort((a) => {
          if (!!body[a.id]) return -1
          return 1
        })

        setUserTableLocale(
          userTableSort?.sort((a) => {
            if (!!body[a.id]) return -1
            return 1
          })
        )

        setAllSettingsFolioUser({ userFolio: bodyFolio, skip: true })

        handledata({ email: dataEndpoint.email, phone: dataEndpoint.phone, name: dataEndpoint.name, responsible: dataEndpoint.responsible })
        if (!!Object.values(body)?.length) {
          setAllUsers({ newSelected: body })
        }
      }
    }
  }


  const handleDeleteSettings = () => {
    if (openModal.id?.toString() === 'all') {
      if (value === TabDepartment.USER) {
        const { body } = unSelectOrSelectAllUsersManage({ value: false })
        setAllUsers({ newSelected: body, skip: true })
      }
      const { body } = unselectOrSelectAllUserFoliosManage({ value: true })
      setAllSettingsFolioUser({ userFolio: body, skip: true })
    } else {
      setSettings({ id: openModal.id })
      if (value === TabDepartment.USER) {
        handleSelectUser({ id: openModal.id?.toString(), value: false, skipCondition: true })
      } else {
        handleSelect({ id: openModal.id?.toString(), value: true, skipCondition: true })
      }
    }
    closeModal()
  }

  const handleSubmit = (payload?: { finish: boolean }) => {
    setSubmitLoading(true)
    submit({ data, userFolioSelected: userFolioSelected, userSelected, userTable, id, finish: payload?.finish })
      .then((response) => {
        if (!response?.errors) {
          navigate(`/dashboard/organization-chart/departments/edit/${id ?? response.id}`)
          setSnackbar(prev => ({ ...prev, type: Types.SUCCESS, message: t(`department.form.modal.${!id ? 'create' : 'edit'}.success.title`), open: true }))
          handleChange(null, payload?.finish ? TabDepartment.FOLIO : TabDepartment.USER)
        } else {
          setSnackbar(prev => ({ ...prev, type: Types.ERROR, message: t(`department.form.modal.${!id ? 'create' : 'edit'}.errors.title`), open: true }))
        }
      })
      .finally(() => {
        setSubmitLoading(false)
      })
  }

  const closeSubmitModal = () => {
    setSubmitModal((prev) => ({
      ...prev,
      open: false,
      openSnackbar: false,
    }))
  }

  const closeBackModal = () => {
    setBackModal((prev) => ({
      ...prev,
      open: false,
    }))
  }

  const returnList = () => {
    navigate('/dashboard/organization-chart/departments')
  }

  const handleSaveSettings = () => {
    const settings =
      !!dataSetting.stores?.length || !!dataSetting.users?.length || !!dataSetting.usersTypes?.length
        ? {
          stores: dataSetting.stores || [],
          users: dataSetting.users || [],
          usersTypes: dataSetting.usersTypes || [],
        }
        : undefined

    setSettings({
      id: openDrawer?.user?.id,
      hierarchy: userFolioSelected[openDrawer?.user?.id]?.hierarchy,
      settings,
    })
    closeDrawer()
  }

  const unSelectOrSelectAllUsersManage = ({ value }: { value: boolean }) => {
    let body: Record<string, boolean> = structuredClone(userSelected)

    const filter = filterRow({ list: userTableLocale, value: dataFilter })
    filter?.forEach((item) => {
      body = {
        ...body,
        [item.id?.toString() ?? '']: value,
      }
    })

    return { body, filter }
  }

  const unSelectOrSelectAllUsers = ({ value }: { value: boolean }) => {
    const { body, filter } = unSelectOrSelectAllUsersManage({ value })

    setAllUsers({ newSelected: body, filter, skip: !!value, unmark: true })
  }

  const unselectOrSelectAllUserFoliosManage = ({ value }: { value: boolean }) => {
    let body: Record<
      string,
      {
        status: boolean
        reassignFolio?: boolean
        settings?:
        | {
          users: Item[]
          usersTypes: Item[]
          stores: Item[]
        }
        | undefined
      }
    > = structuredClone(userFolioSelected)

    const filter = filterRow({ list: rowFolio, value: dataFilter })

    filter?.forEach((item) => {
      body = {
        ...body,
        [item.id?.toString() ?? '']: {
          ...userFolioSelected[item.id?.toString() ?? ''],
          status: value,
          reassignFolio: value,
          ...(!!value && { settings: undefined }),
          hierarchy: undefined,
        },
      }
    })

    return { body, filter }
  }
  const unSelectOrSelectAllUsersFolios = ({ value }: { value: boolean }) => {
    const { body, filter } = unselectOrSelectAllUserFoliosManage({ value })
    setAllSettingsFolioUser({ userFolio: body, skip: !value, filter })
  }

  useEffect(() => {
    getSwitchValues({ value: false })
    //eslint-disable-next-line
  }, [userTable?.length, dataEndpoint.users?.length, itemsSetting])
  const backModalOpen = () => {
    setBackModal((prev) => ({
      ...prev,
      open: true,
      type: Types.SUCCESS,
    }))
  }

  const disableDepartmentForm = useMemo(() => generalDisabled(input, data), [data])
  if (!!submitLoading || !!loadingDetail) return <Loader />
  return (
    <Box sx={styles.container}>
      <BreadCrumb
        removeBreadcrumb={['organization-chart']}
        replaceLabels={{ editEdit: 'editDepartment', create: 'createDepartment' }}
      />
      {/* HEADER */}
      <Box sx={styles.header}>
        <Box sx={styles.headerLeft}>
          <Typography sx={styles.title}>{t(`department.form.${!!id ? 'updateTitle' : 'createTitle'}`)}</Typography>
        </Box>

        {
          value == TabDepartment.FOLIO && (
            <Box sx={[styles.flex, styles.btnFinish]}>
              <IconButton
                sx={(styles.clean, (counter || 0) > 0 ? null : styles.hide)}
                onClick={() => {
                  cleanFilter()
                }}
              >
                {icons('clean')}
              </IconButton>
            </Box>
          )
        }
      </Box>

      <Box sx={[styles.tabsContainer]}>
        <TabContext value={value}>
          <TabList sx={[styles.TabList]} onChange={handleChange} centered>
            <Tab label={t('department.form.tabs.3').toUpperCase()} value={TabDepartment.DEPARTMENT} />

            <Tab disabled={!id} label={t('department.form.tabs.1').toUpperCase()} value={TabDepartment.USER} />

            <Tab disabled={/* !Object.values(userSelected ?? {})?.length ||  */!id} label={t('department.form.tabs.2').toUpperCase()} value={TabDepartment.FOLIO} />
          </TabList>

          <TabPanel value={TabDepartment.DEPARTMENT} sx={styles.TabPanel}>
            <Box sx={styles.form}>
              <Box sx={styles.containerForm}>
                <Typography variant='subtitle' fontWeight='700'>{t('department.departmentData')}</Typography>

                <DinamicForm input={Object.values(input)} onChange={onChange} values={data} />

                <Button disabled={disableDepartmentForm} onClick={handleSubmit} sx={styles.btnSave} variant='contained'>{t('general.save')}</Button>
              </Box>
            </Box>
          </TabPanel>

          <TabPanel value={TabDepartment.USER} sx={styles.TabPanel}>
            <AddUsers
              lastStep={1}
              cleanFilter={() => { createFilter.cleanFilter() }}
              userList={modalLoad?.tmpUsuers as Record<string, string>[]}
              open={false}
              close={cancelSearchUsers}
              rigthItem={<DinamicForm input={Object.values(inputCreate ?? {})} onChange={createFilter.onChange} errors={createFilter.errors} values={createFilter.filterData} />}
              userAmount={modalLoad?.tmpUsuers?.length ?? 0}
              searchButton={{
                disabled: !createFilter.query?.filter,
                loading: !!loadings.search,
                onClick: searchUsers
              }}
              addMessage
              loadData={{
                loading: !!loadings.load,
                onClick: loadUsers
              }}
            />
          </TabPanel>

          <TabPanel value={TabDepartment.FOLIO} sx={styles.TabPanel}>
            <Box sx={styles.titleFolio}>
              <Typography sx={styles.subTitle}>{t('department.form.tabs.titleFolio')}</Typography>

              <Box sx={styles.headerActions} className="user-list-item">
                <Box sx={styles.finishBtn}>
                  {
                    !!deleteSelected?.length && (
                      <Button
                        disabled={generalDisabled(createEdit, data)}
                        onClick={deletedUsersSelecteds}
                        variant="container_error"
                      >
                        {t('general.deleteSelected')}
                      </Button>
                    )
                  }

                  <Button
                    disabled={generalDisabled(createEdit, data)}
                    onClick={() => {
                      if (!generalDisabled(createEdit, data)) {
                        handleSubmit({ finish: true })
                      }
                    }}
                    variant="contained"
                  >
                    {t('general.save')}
                  </Button>
                </Box>

                <Box sx={styles.all}>
                  <Typography
                    sx={styles.select}
                    onClick={() => {
                      unSelectOrSelectAllUsersFolios({ value: true })
                    }}
                  >
                    {t('schedule.buttons.addTruechecket')}
                  </Typography>

                  <Typography sx={styles.line}>|</Typography>

                  <Typography
                    sx={styles.select}
                    onClick={() => {
                      unSelectOrSelectAllUsersFolios({ value: false })
                    }}
                  >
                    {t('schedule.buttons.addFalsechecket')}
                  </Typography>
                </Box>
              </Box>
            </Box>

            {/* TABLE */}
            {!loadingTable ?
              <CustomTable
                tableChecks
                defaultChecks={deleteSelected}
                onClick={(payload) => {
                  setDeletedSelected(payload?.checks ?? [])
                }}
                dontRefresh
                name={t('general.tags.departments')}
                column={columnFolio}
                row={rowFiltered}
                color={colors}
                selected={-1} />
              : <Loader />}
          </TabPanel>
        </TabContext>
      </Box>

      {/* FLOATS */}
      {
        value == TabDepartment.FOLIO && (
          <FiltersDrawer cleanFilter={cleanFilter} count={counter} right={0} top={48}>
            <Box sx={styles.section}>
              <DinamicForm input={Object.values(inputFilter)} values={dataFilter} onChange={filterChange} filter={true} />
            </Box>
          </FiltersDrawer>
        )
      }

      <SnackSimple close={closeSubmitModal} open={submitModal.openSnackbar} type={submitModal.type} message={submitModal.title} />

      <SimpleModal
        open={submitModal.open}
        close={() => {
          closeSubmitModal()
          returnList()
        }}
        title={submitModal.title}
        description={submitModal.description}
        buttonText={t('general.confirm')}
        color={colors}
        next={() => {
          handleDeleteSettings()
          returnList()
        }}
      />
      <SimpleModal
        open={backModal.open}
        close={() => {
          closeBackModal()
        }}
        title={backModal.title}
        buttonText={t('general.confirm')}
        color={colors}
        next={() => {
          closeBackModal()
          returnList()
        }}
      />

      <SimpleModal
        open={openModal.open}
        close={() => {
          closeModal()
        }}
        title={openModal.title}
        description={openModal.description}
        buttonText={t('general.confirm')}
        cancelText={t('general.cancel')}
        color={colors}
        back={() => {
          closeModal()
        }}
        next={() => {
          if (openModal?.confirm) {
            openModal.confirm()
          } else {
            handleDeleteSettings()
          }
        }}
      />

      <SnackSimple close={closeSnackbar} open={snackbar.open} type={snackbar.type} message={snackbar.message} />
      <Drawer sx={styles.drawer} anchor="right" open={openDrawer.setting}>
        <IconButton
          sx={styles.iconClose}
          onClick={() => {
            closeDrawer()
          }}
        >
          {icons('simple-close')}
        </IconButton>

        <Box sx={styles.body}>
          <Typography sx={styles.drawerTitle}>{t('department.form.settings.title')}</Typography>

          <Typography sx={styles.drawerUser}>{t('department.form.settings.user')}</Typography>

          <Typography sx={[styles.title, styles.drawerSpacing]}>{openDrawer?.user?.name ?? ''}</Typography>

          <DinamicForm input={Object.values(settingInput)} onChange={onChangeSetting} values={dataSetting} />
        </Box>

        <Box sx={styles.containerFooter}>
          <Button
            onClick={() => {
              handleSaveSettings()
            }}
            variant="contained"
          >
            {t('department.form.settings.accept')}
          </Button>
        </Box>
      </Drawer>
    </Box>
  )
}

export { FormDepartment }